import React from 'react';
import PropTypes from 'prop-types';
import isFuture from 'date-fns/is_future';

import {
    CloseButton,
    Text,
    Flex,
    Label,
    Spacer,
} from '@zillow/constellation';
import { Col } from '@zillow/zrs-comet';
import { Datepicker } from '@zillow/zrs-rentals';

import { StyledPill } from './StyledComponents';

const propTypes = {
    title: PropTypes.string,
    value: PropTypes.any,
    handleClose: PropTypes.func,
    isFilterOpen: PropTypes.bool,
    handleChange: PropTypes.func,
    disableFuture: PropTypes.bool,
    isDateEnabled: PropTypes.func,
    filters: PropTypes.object.isRequired,
};

const defaultProps = {
    title: '',
    value: null,
    handleClose: () => { },
    isFilterOpen: false,
    handleChange: () => { },
    disableFuture: false,
    isDateEnabled: undefined,
};

const DateFilterPill = ({
    title,
    value,
    handleClose,
    isFilterOpen,
    handleChange,
    keyName,
    disableFuture,
    isDateEnabled,
    filters,
}) => {
    if (!isFilterOpen && !value) return null;
    const validateTimeRange = (date) => {
        if (disableFuture && isFuture(date)) {
            return false;
        }
        if (isDateEnabled) {
            return isDateEnabled(new Date(date), filters);
        }
        return true;
    };

    if (isFilterOpen) {
        return (
            <Col sm={12} md={6} lg={4}>
                <Spacer marginY="xs">
                    <Label>{title}</Label>
                    <Datepicker
                        id={keyName}
                        inputProps={{ placeholder: 'MM/DD/YYYY' }}
                        onChange={(date => handleChange(date))}
                        value={value}
                        getIsValidDate={validateTimeRange}
                    />
                </Spacer>
            </Col>
        );
    }

    return (
        <Col sm={6} md={4}>
            <StyledPill padding="sm" margin="xs">
                <Flex display="flex" justifyContent="space-between">
                    <div>
                        <Text as="div" fontType="bodySmallHeading">{title}</Text>
                        <Text as="div" fontType="bodySmall">{(new Date(value)).toLocaleDateString()}</Text>
                    </div>
                    <CloseButton onClick={() => handleClose(null)} />
                </Flex>
            </StyledPill>
        </Col>
    );
};

DateFilterPill.propTypes = propTypes;
DateFilterPill.defaultProps = defaultProps;

export default DateFilterPill;
